import axios from 'axios';

import AuthenticationStore from '~/auth/authenticationStore';
import Configuration from '~/services/configuration';
import { dedupeWhilePending } from '~/utils/function';

// fetchCsrfToken is imported by createService, so its important that this file does not import any other services (such as pilot)

async function fetchAegisCsrfToken() {
  const AS = AuthenticationStore();
  const refreshToken = AS.getRefreshToken();

  const config = refreshToken
    ? { headers: { Authorization: `Bearer ${refreshToken}` } }
    : { withCredentials: true };

  const response = await axios.get(
    `${Configuration.authEndpoint}/v1/auth/csrf-token`,
    config,
  );
  if (response.status === 200) {
    AS.setCsrf(response.data.csrf_token);
  }
}

async function fetchRolodexCsrfToken() {
  const AS = AuthenticationStore();

  const response = await axios.get(
    `${Configuration.rolodexEndpoint}/api/v1/token/csrf`,
    { withCredentials: true },
  );
  if (response.status === 200) {
    AS.setCsrf(response.data.csrf_token);
  }
}

const baseFetchCsrfToken = async function baseFetchCsrfToken() {
  const AS = AuthenticationStore();

  if (AS.isRolodexAuthed()) {
    await fetchRolodexCsrfToken();
  } else {
    await fetchAegisCsrfToken();
  }
};

const protectedFetchCsrfToken = dedupeWhilePending(baseFetchCsrfToken);

export const fetchCsrfToken = () => {
  return protectedFetchCsrfToken();
};
